import { CDBBtn, CDBSpinner } from 'cdbreact';
import { useEffect, useState } from 'react';
import Select from "react-select";
import { getRolesNamesArray } from '../../api/usersModule/getters';
import data from '../../assets/data/data.json';

export const ModalUsers = ({
	action,
	setPressedButton,
	formData,
	handleChange,
	isLoading,
	handleSelect,
	project,
}) => {
	const [showPassword, setShowPassword] = useState(false);
	const [roles, setRoles] = useState([]);
	const [departamentos, setDepartamentos] = useState([]);
    const [ciudades, setCiudades] = useState([]);
	const [ciudadesDisabled, setCiudadesDisabled] = useState(true);
	const [selectedDepartament, setSelectedDepartament] = useState(formData.UserDepartment || '');

	const getRoles = async () => {
		const roles = await getRolesNamesArray(project);
		if (roles[0] !== 'No hay roles activos') {
			roles.unshift('');
		}
		const rolesTransformed = roles.map(item => ({
			value: item,
			label: item
		}));
		const filteredRoles = rolesTransformed.filter(item => item.value !== "");
		setRoles(filteredRoles);
	};

	const countryCodeOptions = [
		{ value: "+57", label: "+57 (Colombia)" },
		{ value: "+1", label: "+1 (Estados Unidos)" },
		{ value: "+52", label: "+52 (México)" }
	];

	const isCreateAction = action === 'create';
	const isEditAction = action === 'edit';

	// Función para cargar ciudades según el departamento seleccionado
    const handleDepartamentoChange = (selectedDepartamento) => {
		const departamento = data.find(item => item.departamento === selectedDepartamento);
		if (departamento) {
			const ciudadesOptions = departamento.ciudades.map(ciudad => ({
				value: ciudad,
				label: ciudad
			}));
			setCiudades(ciudadesOptions);
			setCiudadesDisabled(false);
		} else {
			setCiudades([]);
			setCiudadesDisabled(true);
		}
	};

	useEffect(() => {
		getRoles();
		const departamentosOptions = data.map(item => ({
			value: item.departamento,
			label: item.departamento
		}));
		setDepartamentos(departamentosOptions);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		handleDepartamentoChange(formData.UserDepartment);

	}, [isEditAction, selectedDepartament]);

	return (
		<div>
			<div className='modal-header'>
				<div>
					<h3 className='modal-title' id='exampleModalLabel'>
						{action === 'create' ? 'Nuevo Usuario' : 'Detalles de Usuario'}
					</h3>
					{action === 'create' ? null : <p>No puedes modificar estos datos</p>}
				</div>
				{action === 'edit' ? (
					<>
						<div>
							<CDBBtn
								size='small'
								className='p-2 btn mb-2'
								color='danger'
								outline
								onClick={() => {
									setPressedButton('delete');
								}}
							>
								<i className='fas fa-trash'></i>
								Eliminar Usuario
							</CDBBtn>
							<CDBBtn
								size='small'
								className='p-2 btn w-100'
								color='primary'
								outline
								onClick={() => {
									setPressedButton('projects');
								}}
							>
								<i className='fas fa-user'></i>
								Permisos
							</CDBBtn>
						</div>
					</>
				) : null}
			</div>

			<div className='modal-body'>
				{action !== 'create' ? (
					<div className='form-group'>
						<label>Id</label>
						<input
							type='text'
							className='form-control mb-4'
							id='userID'
							placeholder='Id'
							disabled
							value={formData.UserID}
						/>
					</div>
				) : null}
				<div className='form-group'>
					<label htmlFor='UserName'>Nombre:<span className="text-danger"> *</span></label>
					<input
						type='text'
						required
						className='form-control mb-4'
						id='UserName'
						placeholder='John Doe'
						value={formData.UserName}
						disabled={isEditAction}
						onChange={(e) =>
							handleChange([
								{ id: "UserName", value: e.target.value }
							])
						}
					/>
				</div>
				<div className='form-group'>
					<label htmlFor='UserEmail'>Correo electrónico:<span className="text-danger"> *</span></label>
					<input
						type='text'
						className='form-control mb-4'
						id='UserEmail'
						placeholder='exampleuser@example.com'
						value={formData.UserEmail}
						disabled={isEditAction}
						onChange={(e) =>
							handleChange([
								{ id: "UserEmail", value: e.target.value }
							])
						}
					/>
				</div>
				{isCreateAction ? (
					<div className='form-group'>
						<label htmlFor='UserPassword'>Contraseña:<span className="text-danger"> *</span></label>
						<div className="input-group mb-4">
							<input
								type={showPassword ? 'text' : 'password'}
								className='form-control'
								id='UserPassword'
								label='User Password'
								placeholder={'···········'}
								value={formData.UserPassword}
								disabled={isEditAction}
								onChange={(e) =>
									handleChange([
										{ id: "UserPassword", value: e.target.value }
									])
								}
							/>
							<button
								className="btn btn-outline-secondary"
								type="button"
								id="togglePassword"
								onClick={() => setShowPassword(!showPassword)}
							>
								<i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
							</button>
						</div>
					</div>
				) : null}

				<div className='d-flex flex-row'>
					<div className='form-group w-20'>
						<label htmlFor='UserCountryCode'>Indicativo País:<span className="text-danger"> *</span></label>
						<Select
							id="UserCountryCode"
							placeholder="Seleccione un indicativo"
							options={countryCodeOptions}
							value={countryCodeOptions.find((option) => option.value === formData.UserCountryCode)}
							onChange={(selectedOption) => {
								handleChange([
								{ id: "UserCountryCode", value: selectedOption.value }
								]);
							}}
						/>
					</div>
					<div className='form-group ms-3 flex-grow-1'>
						<label htmlFor='UserPhone'>Teléfono:<span className="text-danger"> *</span></label>
						<input
							type='text'
							className='form-control mb-4 w-100'
							id='UserPhone'
							label='User Phone'
							placeholder={'Ejemplo: 3108888888'}
							value={formData.UserPhone}
							onChange={(e) =>
								handleChange([
									{ id: "UserPhone", value: e.target.value }
								])
							}
						/>
					</div>
				</div>


				<div className="form-group row mb-4">
					<label htmlFor="UserDepartment">Departamento:<span className="text-danger"> *</span></label>
					<Select
						id="Department"
						placeholder="Seleccione un Departamento"
						options={departamentos}
						value={departamentos.find((option) => option.value === formData.UserDepartment)}
						onChange={(selectedOption) => {
						setSelectedDepartament(selectedOption.value);
						handleChange([
							{ id: "UserDepartment", value: selectedOption.value }
						]);
						}}
					/>
				</div>

				<div className="form-group row mb-4">
					<label htmlFor="UserCity">Ciudad:<span className="text-danger"> *</span></label>
					<Select
						id="City"
						placeholder="Seleccione un Ciudad"
						isDisabled={ciudadesDisabled}
						options={ciudades}
						value={ciudades.find((option) => option.value === formData.UserCity)}
						onChange={(selectedOption) => {
							handleChange([
								{ id: "UserCity", value: selectedOption.value }
							]);
						}}
					/>
				</div>

				{isCreateAction ? (
					<div className='form-group'>
						<label htmlFor='UserRole'>Asignar Rol al usuario:<span className="text-danger"> *</span></label>
						<Select
							id='UserRole'
							label='User Role'
							isDisabled={roles[0] === 'No hay roles activos'}
							options={roles}
							value={roles.find((option) => option.value === formData.UserRole)}
							onChange={(selectedOption) => {
								handleSelect({ id: "UserRole", value: selectedOption.value });
							}}
						/>
				  </div>
				) : null}

				<div className='modal-footer justify-content-center align-items-center'>
					<CDBBtn
						type='button'
						color='danger'
						outline
						onClick={() => setPressedButton('closeModal')}
					>
						Cerrar
					</CDBBtn>
					<CDBBtn
						type='submit'
						color='success'
						className='mr-auto'
						outline
						onClick={() => setPressedButton('submitModal')}
						disabled={isLoading}
					>
						{isLoading ? (
							<>
								<CDBSpinner color='white' size='small' /> <div>{isCreateAction ? 'Guardar' : 'Actualizar'}</div>
							</>
						) : (
							isCreateAction ? 'Guardar' : 'Actualizar'
						)}
					</CDBBtn>
				</div>
			</div>
		</div>
	);
};